import { MediaQueryController } from "@theme/media-query-controller";

class HomepageBannerCarouselController extends MediaQueryController {
  static values = {
    autoplay: Boolean,
    autoplayDelay: Number,
    pauseOnMouseEnter: Boolean,
  };

  connect() {
    this.swiper = this.#initSwiper();

    this.onWindowResize((activeBreakpoint) => {
      if (this.autoplayValue) {
        if (activeBreakpoint === "small") {
          this.swiper.autoplay.stop();
        } else {
          this.swiper.autoplay.start();
        }
      }
    });
  }

  #initSwiper() {
    const shouldLoop = this.hasEnoughSlides();
    return new Swiper(this.element, {
      slidesPerView: 1,
      pagination: {
        el: ".homepage-banner-carousel-pagination",
        bulletActiveClass: "swiper-pagination-bullet-active tw:bg-white",
        bulletClass:
          "swiper-pagination-bullet tw:opacity-100 tw:border tw:border-white tw:bg-transparent",
        clickable: true,
      },
      loop: shouldLoop,
      ...this.#autoplay,
    });
  }

  hasEnoughSlides() {
    return this.element.querySelectorAll(".swiper-slide").length > 1;
  }

  get #autoplay() {
    if (!this.autoplayValue) {
      return null;
    }

    return {
      autoplay: {
        delay: this.autoplayDelayValue,
        pauseOnMouseEnter: this.pauseOnMouseEnterValue,
      },
    };
  }
}

Stimulus.register("homepage-banner-carousel", HomepageBannerCarouselController);
